// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iDkbw","top":"styles_top__3emVp","left":"styles_left__1ycyK","description":"styles_description__2Takd"};